let _ = t => t,
  _t;
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styledWithTheme.span(_t || (_t = _`
  line-height: 16px;
  font-weight: 500;
  font-size: 16px;
  color: ${0};
`), ({
  theme
}) => theme.color['text-core-default']);
const isPhoneNumber = contactDetail => !isNaN(Number(contactDetail));
const ContactDetail = ({
  contactDetail,
  isKnownContact
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledSpan, {
      children: /*#__PURE__*/_jsx(TruncateString, {
        marginBlockEnd: "250",
        children: isKnownContact ? isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: contactDetail
        }) : contactDetail : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.header.unknownVisitorLabel"
        })
      })
    })
  );
};
ContactDetail.displayName = 'ContactDetail';
export default ContactDetail;